// components/icons/TotvsIcon.tsx
"use client";

import Image from "next/image";

interface TotvsIconProps {
  /** Altura do ícone em pixels (por exemplo: 24, 32, 48) */
  height?: number;
}

/**
 * Ícone Totvs (PNG). Por padrão, inverte as cores em light mode e mantém cores originais em dark mode.
 * A altura (em pixels) pode ser controlada via prop `height`.
 */
export function TotvsIcon({ height = 13 }: TotvsIconProps) {
  return (
      <Image
        src="/totvs.png"
        alt="Totvs"
        width={height}
        height={height}
        className="invert dark:invert-0"
        priority
      />
  );
}
